<template>
    <div>
        <section id="section-home" data-stellar-background-ratio="0.5" class="pb-5">
		
            <div class="container pt-5 web-head">
                <div class=" pt-2 row intro-text align-items-center justify-content-center">
                    <div class="col-md-6 text-center pt-5">
                        <center><div class="card" style="background: rgb(0,0,0,0); border: none; box-shadow: 0 2px 6px 0 rgba(255, 255, 255, 0.9), 0 4px 16px 0 rgba(255, 255, 255, 0.19);">
                            <img :src="require('../assets/images/profile.jpg')" class="card-img-top" alt="...">
                        </div></center>
                    </div>
                    <div class="col-md-6 text-center pt-5">
                        <center><h1 class="page-head site-heading site-animate">Hello, I'm <strong style="color: #FFB20A;">Soham Dave</strong></h1></center>
                        <br>
                        <div class="container">
                            <div class="row justify-content-center">
                                <vue-typed-js :strings="['<span>SWE Intern @TESLA &nbsp;</span>','<span>MS CS Grad @USC &nbsp;</span>','<span>Full Stack Web Developer. &nbsp;</span>', '<span>Freelance Developer. &nbsp;</span>', '<span>MERN | MEVN &nbsp; Stack. &nbsp;</span>','<span>Winner of 3x hackathons. &nbsp;</span>','<span>C++ Enthusiastic. &nbsp;</span>','<span>Tech Blogger. &nbsp;</span>']" :typeSpeed="40" :loop="true" :backSpeed="40" :backDelay="1000" :autoInsertCss="true" :contentType="'html'">
                                    <h4 class="text-center"><span class="typing"></span></h4>
                                </vue-typed-js>
                            </div>
                        </div>
                        <div class="site-footer pt-4">
                            <div class="container">
                                <div class="row mb-5">
                                    <div class="col-md-12 text-center">
                                        <p>
                                            <span class="px-1"><a href="https://www.linkedin.com/in/sohamdave08/" target="_blank" class="social-item"><span class="icons"><i class="fab fa-linkedin-in"></i></span></a></span>
                                            <span class="px-1"><a href="https://github.com/SohamDave08" target="_blank" class="social-item"><span class="icons"><i class="fab fa-github"></i></span></a></span>
                                            <span class="px-1"><a href="https://medium.com/@SohamDave08" target="_blank" class="social-item"><span class="icons"><i class="fab fa-medium-m"></i></span></a></span>
                                            <span class="px-1"><a href="https://www.instagram.com/dave_soham/" target="_blank" class="social-item"><span class="icons"><i class="fab fa-instagram"></i></span></a></span>
                                        </p>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </section>
        <br><br><br><br><br><br><br>
        <div class="container pt-5">
            <div class="row justify-content-center">
                <div class="col-md-12 pb-2">
                    <div class="section-heading text-center">
                        <h1 class="page-head site-heading site-animate">About Me</h1>
                    </div>
                </div>
                <div class="col-md-10 align-content-center" style="color: #fff;">
                    <p class="about-head text-center">
                        Hi, I'm Soham Dave. Nice to connect 
                    </p>
                        
                    <p class="about-body pt-3">
I began my journey in software development as a freelancer nearly 2 years ago, I’ve done remote work for software consulting agencies, and startups, and collaborated with motivated coders to create digital ideas improving the consumer’s life.
                    </p>
                    <p class="about-body pt-3">
                        I am currently pursuing a <i style="color: #FFB20A;">Master of Science in Computer Science</i> from the University of Southern California with expected graduation in May 2024. I started my career in Computer Science with a <i style="color: #FFB20A;">Diploma in Computer Science Engineering</i> and graduated in May 2019. Backed up with a <i style="color: #FFB20A;">Bachelor of Engineering in Information Technology</i> from DJ Sanghvi College of Engineering, graduated in May 2022.
                    </p>
                    <p class="about-body pt-3">
                        My primary aim is to gain technical knowledge, solve real-world problems & gain some industrial experience.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "home",
    data: () => ({
    })
}
</script>
<style scoped>
    #section-home{
		padding-top: 150px !important;
	}
	.nav-item{
		font-size: 14px;
		font-weight: 200;
		letter-spacing: .1em;
		position: relative;
		text-transform: uppercase;
		letter-spacing: .2em;
	}
	.navbar-nav > li > a {
	padding: 15px 20px !important;
	}
	
	.icons{
		color: #FFB20A;
	}

	@media only screen and (max-width: 1248px) {
		#section-home{
			padding-top: 250px !important;
		}
	}
	@media only screen and (max-width: 949px) {
		#section-home{
			padding-top: 280px !important;
		}
	}
	@media only screen and (max-width: 416px) {
		#section-home{
			padding-top: 60px !important;
		}
	}
	@media only screen and (max-width: 375px) {
		#section-home{
			padding-top: 50px !important;
		}
    }
    .about-head{
        font-size: 26px;
    }
    .about-body{
        font-size: 20px;
        word-spacing: 1.5px;
    }
</style>